export default function ({ app }) {
  app.head.meta = app.head.meta?.filter(meta => meta.name !== 'generator')
}
